var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._b({class:['c-fontAwesomeIcon', _vm.className],style:(_setup.iconStyle)},'div',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }